function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["class", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { decodeHtmlEntities } from '@finect/front-utils/html';
import { RawHTML } from './RawHTML';
import { getSizeFromURL } from './utils';
import { AutocloseNode, TableWrapper, StyledNode } from './partials';
import { INLINE_TAGS, NOT_ALLOWED_TAGS, CUSTOM_ATTRIBUTES, NODE_TYPE } from './data';
var CUSTOM_ATTRIBUTES_OPTIONS = {
  a: {
    flags: ['ugc', 'nofollow', 'noopener', 'noreferrer']
  }
};
var CUSTOM_TAG_CHANGES = {
  h1: 'h2'
};
export var Node = function Node(_ref) {
  var node = _ref.node,
    actions = _ref.actions,
    _ref$data = _ref.data,
    data = _ref$data === void 0 ? {} : _ref$data,
    firstNodeTag = _ref.firstNodeTag,
    _ref$recursive = _ref.recursive,
    recursive = _ref$recursive === void 0 ? true : _ref$recursive,
    _ref$allowedTags = _ref.allowedTags,
    allowedTags = _ref$allowedTags === void 0 ? [] : _ref$allowedTags,
    _ref$features = _ref.features,
    features = _ref$features === void 0 ? [] : _ref$features,
    getWidgetComponent = _ref.getWidgetComponent;
  var childNodes = node.childNodes;
  if (node.nodeType === NODE_TYPE.ELEMENT_NODE) {
    var tagName = node.rawTagName || firstNodeTag || 'div';
    if (allowedTags.length && !allowedTags.includes(tagName.toLowerCase())) {
      return null;
    }
    if (tagName.toLowerCase() === 'script' && !node.attributes.hasOwnProperty('src')) {
      return null;
    }
    if (tagName.toLowerCase() === 'script') {
      return React.createElement(RawHTML, {
        ssr: false,
        html: node.outerHTML
      });
    }
    if (recursive && tagName.toLowerCase() === 'table') {
      return React.createElement(TableWrapper, {
        size: "large",
        withStyles: features.includes('table')
      }, React.createElement(Node, {
        node: node,
        recursive: false,
        getWidgetComponent: getWidgetComponent
      }));
    }
    var customWidgetDefinition = getWidgetComponent && getWidgetComponent(node);
    if (recursive && customWidgetDefinition) {
      var CustomComponent = customWidgetDefinition.component,
        _customWidgetDefiniti = customWidgetDefinition.props,
        props = _customWidgetDefiniti === void 0 ? function (callBackNode, callbackData) {
          return {};
        } : _customWidgetDefiniti;
      var customProps = props(node, data);
      return React.createElement(CustomComponent, _extends({
        actions: actions
      }, customProps));
    }
    if (NOT_ALLOWED_TAGS.includes(node.rawTagName)) {
      return null;
    }
    var attributes = CUSTOM_ATTRIBUTES.hasOwnProperty(tagName) ? CUSTOM_ATTRIBUTES[tagName](node, CUSTOM_ATTRIBUTES_OPTIONS[tagName] || {}) : node.attributes;
    var changedClass = attributes.class,
      style = attributes.style,
      cleanAttributes = _objectWithoutProperties(attributes, _excluded);
    var nodeProps = _objectSpread(_objectSpread({}, cleanAttributes), {}, {
      className: node.classList.join(' ')
    });
    if (INLINE_TAGS.includes(node.rawTagName)) {
      if (['img'].includes(node.rawTagName)) {
        var size = getSizeFromURL(nodeProps.src || '');
        if (size && size.width) nodeProps.width = "".concat(size.width, "px");
        if (size && size.height) nodeProps.height = "".concat(size.height, "px");
        if (node.classList.some(function (className) {
          return ['image-right-side', 'image-left-side'].includes(className);
        })) {
          var inlineCSS = "\n          ".concat(style, "\n          ").concat(node.classList.includes('image-left-side') ? "float: left; margin-right: 14px;" : '', "\n          ").concat(node.classList.includes('image-right-side') ? "float: right; margin-left: 14px;" : '', "\n        ");
          return React.createElement(AutocloseNode, _extends({
            as: tagName,
            customCSS: inlineCSS
          }, nodeProps));
        }
        if (node.classList.includes('image_resized')) {
          return React.createElement(AutocloseNode, _extends({
            as: tagName,
            customCSS: style
          }, nodeProps, {
            className: "image_resized"
          }));
        }
      }
      return React.createElement(AutocloseNode, _extends({
        as: tagName
      }, nodeProps, {
        className: "image_resized"
      }));
    }
    return React.createElement(StyledNode, _extends({
      as: CUSTOM_TAG_CHANGES[tagName] || tagName,
      customCSS: style
    }, nodeProps), childNodes.map(function (child, key) {
      return React.createElement(Node, {
        key: key,
        node: child,
        actions: actions,
        data: data,
        recursive: recursive,
        features: features,
        getWidgetComponent: getWidgetComponent
      });
    }));
  }
  if (node.nodeType === NODE_TYPE.TEXT_NODE) {
    return decodeHtmlEntities(node.text);
  }
  return null;
};